// Module
var code = "<md-slider-container>\n    <md-slider flex md-discrete ng-model=\"vm.contraste\" step=\"2\" min=\"-10\" max=\"100\" aria-label=\"rating\" ng-change=\"vm.contrast()\">\n    </md-slider>\n</md-slider-container>";
// Exports
module.exports = code;